// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

// eslint-disable-next-line import/no-extraneous-dependencies
import Splide from "@splidejs/splide";

// https://splidejs.com/guides/options/

((Drupal, once) => {
  Splide.defaults = {
    type: "loop",
    perPage: 1,
    perMove: 1,
    arrows: true,
    pagination: true,
    autoplay: false,
    mediaQuery: "min",
    rewind: true,
    gap: "3.2rem",
  };

  function singleFix(slider) {
    slider.on("mounted", () => {
      if (slider.length === 1) {
        slider.options = {
          pagination: false,
          arrows: false,
        };
      }
    });
  }

  Drupal.behaviors.mediaSlider = {
    attach: (context) => {
      const mediaSliders = once("media-slider", ".pg-media__slider", context);

      mediaSliders.forEach((elm) => {
        const slider = new Splide(elm, {});
        singleFix(slider);
        slider.mount();
      });

      const pgMediaSliders = once(
        "pg-media-slider",
        ".pg-pg-media__slider",
        context,
      );

      pgMediaSliders.forEach((elm) => {
        const slider = new Splide(elm, {});
        singleFix(slider);
        slider.mount();
      });

      const collageSliders = once(
        "collage-sliders",
        ".pg-collage__slider",
        context,
      );

      collageSliders.forEach((elm) => {
        const slider = new Splide(elm, {
          type: "slide",
          pagination: false,
          lazyLoad: "nearby",
          breakpoints: {
            576: {
              perPage: 1,
              perMove: 1,
            },
            700: {
              perPage: 2,
              perMove: 1,
            },
            992: {
              perPage: 4,
              perMove: 1,
            },
          },
        });
        singleFix(slider);
        slider.mount();
      });

      const logoSliders = once("logoSliders", ".pg-logos__slider", context);

      logoSliders.forEach((elm) => {
        const slider = new Splide(elm, {
          pagination: true,
          breakpoints: {
            576: {
              perPage: 1,
              perMove: 1,
            },
            768: {
              perPage: 2,
              perMove: 1,
            },
            992: {
              perPage: 3,
              perMove: 1,
            },
            1202: {
              perPage: 5,
              perMove: 1,
            },
          },
        });
        singleFix(slider);
        slider.mount();
      });
    },
  };
})(Drupal, once);
